'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import Loader from '@Pure/Loader'

let app = window.app;

export default class Logo extends Component
{
	state = { };

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props;

		component.handleSessionChange('WillMount');

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			EC: app.state.session.EC
			? _.cloneDeep(app.state.session.EC)
			: undefined,

			permissions: app.state.session.permissions?.title
		});
	}

	render ()
	{
		const component = this, props = this.props, state = component.state;

		let src = '/images/logo/2025/synergies_paysage_small.png', alt;

		if (props.type === 'svg')
		{
			src = '/images/logo/2025/synergies_paysage.svg';
		}
		else if (props.type === 'big')
		{
			src = '/images/logo/2025/synergies_paysage.png';
		}
		else if (props.type === 'portrait-big')
		{
			src = '/images/logo/2025/synergies.png';
		}
		else if (props.type === 'portrait-small')
		{
			src = '/images/logo/2025/synergies_small.png';
		}
		else if (props.type === 'portrait-mini')
		{
			src = '/images/logo/2025/synergies_mini.png';
		}

		if (props.dynamic && !state.EC?.id && !app.state.session?.EC &&
			state.permissions !== 'Membre de synergies')
		{
			const output =
			(
				<div className={ props.className || 'u-responsive-img' }>
					<Loader className="c-loader"
						bemit={ ['primary', 'bg-transparent'] }
					/>
				</div>
			);

			return output;
		}

		const EC = state.EC || app.state.session?.EC || { };

		let EC_logo = EC.logo instanceof Array ? EC.logo : [];

		EC_logo = (EC_logo[0] || { }).url;

		if (EC_logo && props.synergies !== true)
		{
			src = EC_logo;

			if (EC.company)
			{
				alt = 'Logo ' + EC.company;
			}
		}

		var output =
		(
			<img className={ props.className || 'u-responsive-img' }
				title={ props.title } src={ src }
				alt={ (alt || props.alt) || 'Logo Synergies' }
			/>
		);

		return output;
	}
}